/* AA: pre-warm product-card SECOND images (the hover/swipe image). They render
   loading="lazy" but sit clipped/stacked out of view, so the browser only started the
   download when the hover/swipe revealed them — a white flash while it fetched. After
   window load, when the browser is idle, flip ONE second image per card to eager,
   staggered ~80ms apart so the warm-up never competes with visible content. Cards added
   later (load-more pagination) are warmed by re-running on facet/grid re-renders. */
(function () {
  function warm() {
    var seen = [];
    document.querySelectorAll('img.media--second[loading="lazy"]').forEach(function (img) {
      var card = img.closest('.card-wrapper');
      if (card) {
        if (seen.indexOf(card) !== -1) return; /* only the FIRST extra image per card */
        seen.push(card);
      }
      setTimeout(function () {
        img.setAttribute('loading', 'eager');
      }, seen.length * 80);
    });
  }

  function idle(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 3000 });
    else setTimeout(fn, 1500);
  }

  if (document.readyState === 'complete') idle(warm);
  else window.addEventListener('load', function () { idle(warm); });

  /* Load-more / facet re-renders insert fresh lazy cards — warm those too, debounced. */
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { idle(warm); }, 500);
  }).observe(document.body, { childList: true, subtree: true });
})();
